import config from '../config.json';
import { sha224 } from 'js-sha256';
import { Env } from '../interfaces/globaleInterface';
import { headers } from './genericConstantes';
import { DashboardConfig, UrlConfig } from '../models/urlConfig';
import {
    getPreviewApiUrl,
    getPreviewPrimCoreApiUrl,
    getStoredPreviewNumber,
} from './previewEnvironmentService';

const getEnvironmentApiUrl = (env: Env, previewNumber?: number | null): string => {
    if (env === Env.PREVIEW) {
        const selectedPreviewNumber = previewNumber || getStoredPreviewNumber();
        if (!selectedPreviewNumber) {
            throw new Error('Aucune PR Preview n’est sélectionnée.');
        }

        return getPreviewApiUrl(selectedPreviewNumber);
    }

    const urlAvailable: UrlConfig = config.url;
    return urlAvailable[env as keyof UrlConfig];
};
/**
 * Get Token, pour la connexion
 * Obligation de mettre any car si le login est incorrect on aura une réponse complètement différente d'un bon login
 * @param login 
 * @returns 
 */
export const ApiGetToken = async (env: Env, login: string, password: string, previewNumber?: number | null): Promise<void | any> => {
    const encodedPassword = sha224(password);
    const envUrl = getEnvironmentApiUrl(env, previewNumber);

    const requestOptions = {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({
            password: encodedPassword,
            userLogin: login,
            device: {"uniqueId" : 'dashboard-device', "operatingSystem" : 'PC', "brand" : 'PHF'},
			application: { "name" : 'Dashboard' }
        }),
    }
    const response = await fetch(`${envUrl}/user/login`, requestOptions)
        .then(async (response: any) => { 
            const responseJson = await response.json();
            if (response.ok) {
                return responseJson
            } else {
                throw responseJson
            }
         })
        .catch((error) => {
           throw error;
        });

    return response
}
/**
 * retourne le token courant via le localstorage
 */
export const getCurrentToken = (): string =>{
    return localStorage.getItem('token') || "";
}

/**
 * retourne l'url de l'environnement courant via le localstorage
 * @returns string
 */
export const getCurrentUrl = (): string => {
    const env = getCurrentEnv();
    return getEnvironmentApiUrl(env);
}

/**
 * Retourne l'URL PrimCore de l'environnement courant.
 * L'API historique reste exposée par getCurrentUrl().
 */
export const getCurrentPrimCoreUrl = (): string => {
    const dashboardConfig = config as DashboardConfig;
    const env = getCurrentEnv();

    if (env === Env.PREVIEW) {
        const previewNumber = getStoredPreviewNumber();
        if (!previewNumber) {
            throw new Error('Aucune PR Preview n’est sélectionnée.');
        }

        return getPreviewPrimCoreApiUrl(previewNumber);
    }

    const primCoreUrl = dashboardConfig.primCoreUrl?.[env as keyof UrlConfig];

    if (!primCoreUrl) {
        throw new Error(`URL PrimCore non configurée pour l'environnement ${env}.`);
    }

    return primCoreUrl;
}

/**
 * retourne l'environnement courant via le localstorage
 */
export const getCurrentEnv = (): Env =>{
    return (localStorage.getItem('env') || 'dev') as Env;
}

